(function () {
  if (window.twpcMailchimpReady) return;
  window.twpcMailchimpReady = true;
  var sequence = 0;

  function subscribe(form, fields) {
    return new Promise(function (resolve, reject) {
      var callback = 'twpcMailchimpCallback' + Date.now() + (++sequence);
      var script = document.createElement('script');
      var url = new URL(form.dataset.mcAction.replace('/subscribe/post', '/subscribe/post-json'));
      Object.keys(fields).forEach(function (key) {
        if (fields[key] !== '') url.searchParams.set(key, fields[key]);
      });
      url.searchParams.set('c', callback);
      var timer = setTimeout(function () { finish(); reject(new Error('timeout')); }, 20000);
      function finish() {
        clearTimeout(timer);
        script.remove();
        window[callback] = function () {};
        setTimeout(function () { delete window[callback]; }, 60000);
      }
      window[callback] = function (result) { finish(); resolve(result); };
      script.onerror = function () { finish(); reject(new Error('network')); };
      script.src = url.toString();
      document.head.appendChild(script);
    });
  }

  function plainMessage(message) {
    return String(message || '').replace(/<[^>]*>/g, '').replace(/^\d+\s*-\s*/, '');
  }

  function bind(root) {
    root.querySelectorAll('[data-twpc-mailchimp]').forEach(function (config) {
      var form = config.matches('form') ? config : config.closest('form');
      if (!form) return;
      Object.keys(config.dataset).forEach(function (key) { form.dataset[key] = config.dataset[key]; });
      if (form.dataset.mcBound) return;
      form.dataset.mcBound = 'true';
      var button = form.querySelector('[type="submit"]');
      if (!button) return;
      var label = button.textContent;
      var status = form.querySelector('[data-mc-status]');
      var fallback = form.querySelector('[data-mc-fallback]');
      var application = form.dataset.twpcMailchimp === 'application';
      var busy = false;

      function value(name) {
        var field = form.elements.namedItem(name);
        return field && typeof field.value === 'string' ? field.value.trim() : '';
      }
      function say(message) {
        status.hidden = false;
        status.textContent = message;
      }
      function applicationBody(mcStatus) {
        form.elements.namedItem('contact[mailchimp_status]').value = mcStatus;
        form.elements.namedItem('contact[subject]').value = form.dataset.mcSource + ' - ' + value('contact[first_name]') + ' ' + value('contact[last_name]');
        form.elements.namedItem('contact[body]').value = [
          'Submission Source: ' + form.dataset.mcSource,
          'Mailchimp Tag: ' + form.dataset.mcTagName,
          'Mailchimp Result: ' + mcStatus,
          'First Name: ' + value('contact[first_name]'),
          'Last Name: ' + value('contact[last_name]'),
          'Email: ' + value('contact[email]'),
          'Phone: ' + value('contact[phone]'),
          'Business / Brand: ' + value('contact[business]'),
          'Website or Social: ' + value('contact[website_or_social]'),
          'Category: ' + value('contact[category]'),
          'Consent: ' + value('contact[application_consent]'),
          '', 'Message:', value('contact[message]'),
          '', 'Additional Details:', value('contact[extra]')
        ].join('\n');
      }
      function sendApplication(mcStatus) {
        applicationBody(mcStatus);
        HTMLFormElement.prototype.submit.call(form);
      }
      fallback.addEventListener('click', function () {
        if (busy || !form.reportValidity()) return;
        if (application) sendApplication('Mailchimp signup not confirmed; application sent through Shopify.');
        else HTMLFormElement.prototype.submit.call(form);
      });
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        if (application) {
          var empty = Array.from(form.querySelectorAll('[required]')).find(function (field) {
            return field.type !== 'checkbox' && !field.value.trim();
          });
          if (empty) { empty.focus(); say(form.dataset.msgRequired); return; }
        }
        busy = true;
        button.disabled = true;
        button.textContent = form.dataset.msgPending;
        fallback.hidden = true;
        say(form.dataset.msgPending);
        var fields;
        if (application) {
          fields = {
            EMAIL: value('contact[email]'), FNAME: value('contact[first_name]'),
            LNAME: value('contact[last_name]'), PHONE: value('contact[phone]'),
            BUSINESS: value('contact[business]').slice(0, 255),
            WEBSITE: value('contact[website_or_social]').slice(0, 255),
            CATEGORY: value('contact[category]').slice(0, 255),
            MESSAGE: value('contact[message]').slice(0, 255),
            EXTRA: value('contact[extra]').slice(0, 255),
            FORMSOURCE: form.dataset.mcSource, tags: form.dataset.mcTags
          };
          fields[form.dataset.mcHoneypot] = value(form.dataset.mcHoneypot);
        } else {
          fields = {};
          new FormData(form).forEach(function (entry, key) { fields[key] = String(entry).trim(); });
        }
        if (fields[form.dataset.mcHoneypot]) {
          busy = false;
          button.disabled = false;
          button.textContent = label;
          say(form.dataset.msgError);
          return;
        }
        try {
          var result = await subscribe(form, fields);
          var message = plainMessage(result.msg);
          var alreadySubscribed = /already subscribed/i.test(message);
          if (application && (result.result === 'success' || alreadySubscribed)) {
            sendApplication(alreadySubscribed ? 'Already subscribed; existing Mailchimp contact may require tag/detail updates.' : 'Mailchimp accepted signup: ' + message);
            return;
          }
          if (!application && result.result === 'success') {
            say(message || form.dataset.msgSuccess);
            form.reset();
          } else if (!application && alreadySubscribed) {
            say(form.dataset.msgAlready);
          } else {
            say(message ? form.dataset.msgError + ' ' + message : form.dataset.msgError);
            fallback.hidden = false;
          }
        } catch (error) {
          say(form.dataset.msgNetwork);
          fallback.hidden = false;
        }
        busy = false;
        button.disabled = false;
        button.textContent = label;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();
